import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UserAccountRole } from '@shared/user/enums';
import { CanActivateRoute } from '../../guards';

const preferencesRoutes: Routes = [
  {
    path: '',
    redirectTo: 'waitlist',
    pathMatch: 'full',
  },
  {
    path: 'notifications',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-notifications" */ './notifications/notifications.module')
      .then(module => module.NotificationsModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'automations',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-automations" */ './automations/automations.module')
      .then(module => module.AutomationsModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'waitlist',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-waitlist-options" */ './waitlist-options/waitlist-options.module')
      .then(module => module.WaitlistOptionsModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'reservation',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-reservation-options" */ './reservation-options/reservation-options.module')
      .then(module => module.ReservationOptionsModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'schedules',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-schedules" */ './schedules/schedules.module')
      .then(module => module.SchedulesModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'services',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-services" */ './services/services.module')
      .then(module => module.ServicesModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'resources',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-resources" */ './resources/resources.module')
      .then(module => module.ResourcesModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'alerts-settings',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-alerts-settings" */ './alerts/alerts-settings.module')
      .then(module => module.AlertsSettingsModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'public-pages',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-public-pages" */ './public-options/public-options.module')
      .then(module => module.PublicOptionsModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'integrations',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-integrations" */ './integrations/integrations.module')
      .then(module => module.IntegrationsModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
  {
    path: 'party-fields',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-party-fields" */ './party-fields/party-fields.module').then(module => module.PartyFieldsModule),
    canActivate: [CanActivateRoute],
    data: {
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
      scopes: ['manager:read'],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(preferencesRoutes)],
  exports: [RouterModule],
})
export class PreferencesRoutingModule {}
